import React from 'react';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { getBreakpoint } from '../../../Base/Breakpoints';
// import assets
import './responsiveBGImage.scss';
import { closeImagePlayer, openImagePlayer, setImagePlayerImages, setInitialIndex } from '../../../Base/Actions';

class ResponsiveBGImage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      imageSrc: '',
      resizeId: 0,
    };

    this.reRenderImage = this.reRenderImage.bind(this);
    this.setImagePlayerImages = this.setImagePlayerImages.bind(this);
  }

  componentDidMount() {
    this.updateSrc(this.props.src);
    window.addEventListener('resize', this.reRenderImage);
  }

  componentWillReceiveProps(nextProps) {
    this.updateSrc(nextProps.src);
  }

  componentWillUnmount() {
    clearTimeout(this.state.resizeId);
    window.removeEventListener('resize', this.reRenderImage);
  }

  setImagePlayerImages(index) {
    this.props.openImagePlayer();
    this.props.setImagePlayerImages(this.props.imageCollection);
    this.props.setInitialIndex(index);
  }

  updateSrc(sources) {
    if (sources) {
      const breakpoint = getBreakpoint();
      let src;
      switch (breakpoint) {
        case 'sm':
          src = sources.sm || '';
          break;
        case 'md':
          src = sources.md || '';
          break;
        case 'lg':
          src = sources.lg || '';
          break;
        case 'xl':
          src = sources.xl || '';
          break;
        case 'xxl':
          src = sources.xxl || '';
          break;
        case 'xxxl':
          src = sources.xxl || '';
          break;
        default:
          src = sources.default || '';
      }

      if (src === '' && sources.default) {
        src = this.props.src.default;
      }

      if (src !== this.state.imageSrc) {
        this.setState({
          imageSrc: src,
        });
        this.forceUpdate();
      }
    }
  }

  reRenderImage() {
    clearTimeout(this.state.resizeId);
    this.setState({
      resizeId: setTimeout(() => {
        this.updateSrc();
      }, 100),
    });
  }

  render() {
    let className = this.props.className;
    if (this.props.imageCollection.length > 0) {
      className += ' m-picture--clickable';
    }
    return (
      <LazyLoad once offset={0} height={200}>
        <div
          onClick={() => {
            if (!this.props.disableZoom) {
              this.setImagePlayerImages(this.props.collectionIndex);
            }
          }}
          role={'button'}
          tabIndex={-1}
          className={`m-responsive-bg-image ${className}`}
          style={{ backgroundImage: `url( ${this.state.imageSrc})` }}
        >
          {this.props.children}
          {(() => {
            if (this.props.imageCollection && !this.props.disableZoom) {
              return (<div className={'m-zoomIn'}>
                <svg>
                  <use xlinkHref="#Lenspire_Icon_ZoomIn" />
                </svg>
              </div>);
            }
            return null;
          })()}
        </div>
      </LazyLoad>
    );
  }
}

function mapStateToProps(state) {
  return {
    ...state.imagePlayerState,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ closeImagePlayer, openImagePlayer, setImagePlayerImages, setInitialIndex }, dispatch);
}

ResponsiveBGImage.propTypes = {
  className: PropTypes.string,
  src: PropTypes.shape({
    sm: PropTypes.string,
    md: PropTypes.string,
    lg: PropTypes.string,
    xl: PropTypes.string,
    xxl: PropTypes.string,
    xxxl: PropTypes.string,
    default: PropTypes.string,
  }),
  children: PropTypes.node,
  disableZoom: PropTypes.bool,
  openImagePlayer: PropTypes.func.isRequired,
  setImagePlayerImages: PropTypes.func.isRequired,
  setInitialIndex: PropTypes.func.isRequired,
  imageCollection: PropTypes.arrayOf(PropTypes.shape()),
  collectionIndex: PropTypes.number,
};

ResponsiveBGImage.defaultProps = {
  className: '',
  src: {
    sm: '',
    md: '',
    lg: '',
    xl: '',
    xxl: '',
    xxxl: '',
    default: '',
  },
  children: null,
  disableZoom: false,
  imageCollection: [],
  collectionIndex: 0,
};

export default connect(mapStateToProps, mapDispatchToProps)(ResponsiveBGImage);



// WEBPACK FOOTER //
// ./frontend/js/Components/Util/ResponsiveBGImage/ResponsiveBGImage.jsx